let controller = function (
	$rootScope,
	$scope,
	$state,
	$stateParams,
	$ionicHistory,
	$ionicLoading,
	$ionicScrollDelegate,
	$ionicModal,
	$ionicNavBarDelegate,
	$location,
	$timeout,
	Product,
	Search,
	Session,
	Filter,
	_,
	$ionicLoadingConfig
) {
	"ngInject"
	
	var loadingConfig = angular.copy($ionicLoadingConfig);

	loadingConfig.scope = $scope;
	loadingConfig.template = '<a ng-click="cancelRequest()">'+$ionicLoadingConfig.template+'<br>{{ "cancel" | translate | ucfirst }}</a>';

	var vm = this;
	var page = 1;
	var sort;
	var order;
	var all;
	var categories = Filter.getActive('categories');
	var listen;
	var request;
	
	vm.error = false;
	vm.gridView = Session.get('gridView') ? Session.get('gridView') : false;

	function initialize() {

		vm.processEnabled = categories && categories.length === 1;

		$ionicLoading.show(loadingConfig);
		Filter.get({categories: categories ? categories.join(',') : null}).then(res => {
			Filter.loadInterface(res);
		});
	}

	$scope.cancelRequest = function() {
		request.cancel();
		$ionicLoading.hide();
	}

	var refresh = function() {
		
		$ionicLoading.show(loadingConfig);

		request = Product.all({
			uid: vm.uids,
			all: all,
			limit: 12,
			sort: sort,
			order: order,
			webshop: Filter.getActive('webshop')
		})

		page = 1;
		request.promise.then(function(result) {
			$ionicLoading.hide();
			vm.error = false;
			vm.count = vm.uids.length;
			vm.products = result;
		}).catch(function(err) {
			$ionicLoading.hide();
			vm.error = true;
			vm.count = 0;
			vm.products = [];
		}).finally(function() {
			$ionicScrollDelegate.$getByHandle('search').scrollTop();
		});
	}

	vm.nextPage = function() {

		$ionicLoading.show(loadingConfig);
		request = Product.all({
			uid: vm.uids,
			all: all,
			sort: sort,
			limit: 12,
			order: order,
			page: page+1,
			webshop: Filter.getActive('webshop')
		})

		request.promise.then(function(result) {
			$ionicLoading.hide();
			page++;
			vm.error = false;
			vm.products = vm.products.concat(result);
			$timeout(function() {
				vm.filtering = false;
				$ionicScrollDelegate.$getByHandle('search').scrollBy(0, 400, true);
			}, 200);
		}).catch(function() {
			vm.error = true;
		});
	}

	vm.toProcess = function() {
		$state.go('tab.category');
	}

	vm.sort = Search.sortOptions();
	vm.sortDefault = {
		sort: (function() {
			var selectedSort;
			if($stateParams.sort && $stateParams.order) {
				angular.forEach(vm.sort, function(s) {
					if(s.key === $stateParams.sort && s.order === $stateParams.order) {
						selectedSort = s;
					}
				});
			} else {
				selectedSort = vm.sort[0];
			}
			return selectedSort;
		})()
	};

	vm.sortChange = function(sortObj) {
		sort = sortObj.key;
		order = sortObj.order;
		refresh();
	};

	vm.toggle = {
		price: function(price) {
			Filter.toggle.price(price);
			Filter.change(true);
		},
		brand: function(brand) {
			Filter.toggle.brand(brand);
			Filter.change(true);
		},
		category: function(category) {
			Filter.toggle.category(category);
			categories = Filter.getActive('categories');
			initialize();
		},
		gridView: function() {
			vm.gridView = !vm.gridView;
			Session.set('gridView', vm.gridView);
			$ionicScrollDelegate.$getByHandle('search').scrollTop();
		},
		filter: (attributeId, option) => {
			Filter.clearFilter(attributeId);
			Filter.change(true);
		},
		skey: () => {
			Filter.setActive('skey', undefined);
			Filter.change(true);
		}
	};


	$scope.$on('PRODUCTS_CHANGED', function(event, uids, bool){	
		if (listen) {
			all = bool;
			vm.uids = uids;
			refresh();
		}
	});

	$scope.$on('filters:pills', function(e, pills) {
		vm.pills = pills;
	})

	$scope.$on('filters:reload', function() {
		categories = Filter.getActive('categories');
		initialize();
	})

	$scope.$on('$ionicView.enter', function(e, data) {
		var reload;
		listen = true;

		if (Filter.getActive('definitions')) {
			Filter.setActive('definitions');
			reload = true;
		}

		if (!_.isEqual(categories, Filter.getActive('categories'))) {
			reload = true;
			categories = Filter.getActive('categories');
		}

		if (reload) initialize();
	})

	$scope.$on('$ionicView.beforeLeave', function(e, data) {
		listen = false;
	})

	$scope.$on('$ionicView.loaded', function(e, data) {
		listen = true;
		initialize();
	})
}

export default controller;


// WEBPACK FOOTER //
// ./app/components/search/search.controller.js